import "./notification-popup.scss";
import { Dispatch, SetStateAction } from "react";
import { NotificationResponse } from "pages/authentication/userService";
import Notification from "./Notification";
interface NotsProps {
  notifications: NotificationResponse[] | undefined; 
 setNotifications: Dispatch<SetStateAction<NotificationResponse[] | undefined>>;
}

export default function NotificationPopup({ notifications, setNotifications }: NotsProps) {
  const handleRemoveViewedNotification = (id: string) => {
    setNotifications((prev) =>
      prev?.filter((notification) => notification.id !== id)
    );
  };
  return (
    <div className="notify-popup-container">
      <div className="notifiy-scroll">
        {notifications?.map((data, index) => (
          <Notification
            id={data.id}
            userId={data.userId}
            nhDealApplicationId={data.nhDealApplicationId}
            title={data.title}             
            text={data.text}
            link={data.link}
            createdOn={data.createdOn}
            key={data.id || index}
            onRemoveViewedNotification={handleRemoveViewedNotification}
          />
        ))}
      </div>
    </div>
  );
}
